import { useEffect, useState } from 'react';
import { GoSearch } from 'react-icons/go';

import LoaderStore from '../store/loader';

import styles from './NoProductsPlaceholder.module.scss';

export default function NoProductsPlaceholder() {
  const [loaderIsVisible, setLoaderIsVisible] = useState();

  useEffect(() => {
    const loader$ = LoaderStore.subscribe(({ isVisible }) => {
      setLoaderIsVisible(isVisible);
    });

    return () => {
      loader$.unsubscribe();
    };
  }, []);

  if (loaderIsVisible) return null;
  return (
    <div className={styles.noProductsContainer}>
      <GoSearch className={styles.icon}/>
      <p className={styles.noProducts}>Δεν υπάρχουν προϊόντα διαθέσιμα για άμεση παράδοση σε αυτή την κατηγορία.</p>
    </div>
  );
}
